
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles/index";
import { Modal, Button, Alert } from "react-bootstrap";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactDatePicker from "../../UI/ReactOnlyTimePicker";
import ReactSelectMulti from "../../UI/ReactMultiSelect";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#072C8C",
  },
});
const initialValues = {
  operation: '',
  time: '',
  deviceIds: '',
  status: ''
};

export default function Edit(props) {
  const classes = useStyles();
  const {
    onHide,
    show,
    onCards,
    chooseCardId,
    onCardChoose,
    skip,
    take,
    sortField,
    orderBy,
    filterInputs,
    device
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [oldValue, setOldValue] = useState()
  const [deviceOption, setDeviceOption] = useState(null)

  const onPutCard = (values, resetForm, setSubmitting) => {
    setIsEditLoading(true)
    const card = {
      status: values.status ? "ACTIVE" : "INACTIVE",
      time: values.time,
      operation: values.operation,
      deviceIds: oldValue
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}sync/data`, card
      )
      .then(() => {
        onHide(false);
        resetForm();
        setSubmitting(false);
        onCards(orderBy, sortField, skip, take, filterInputs,);
        setIsEditLoading(false)
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.checks ? err.response.data.checks.number : err.response.data.message && err.response.data.message
            : err.message;
        setIsError(message);
        setIsEditLoading(false)
      });

  };


  const EditSchema = Yup.object().shape({
    time: Yup.string().required('Vaxt tələb olunur.'),

  });


  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const formik = useFormik({
    initialValues,
    validationSchema: EditSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPutCard(values, resetForm, setSubmitting);
    },
  });

  const { setFieldValue } = formik;

  const handleChangeDevice = (value) => {
    setDeviceOption(value)
    const mockArray = []
    if (value) {
      value.forEach(element => {
        mockArray.push(element.value)
      });
    }
    setOldValue(mockArray)
    setFieldValue("deviceIds", mockArray);

  }



  useEffect(() => {
    setIsLoading(true);
    onCardChoose(chooseCardId)
      .then((res) => {
        setFieldValue("time", res.data.time);
        setFieldValue("status", res.data.status == 'ACTIVE' ? true : false);
        setFieldValue("operation", res.data.operation);
        const devices = res.data.devices.map(
          ({ id, name }) => ({
            value: id,
            label: name,
          })
        );

        const oldValue = res.data.devices.map(
          ({ id }) => id
        );
        setOldValue(oldValue);
        setDeviceOption(devices);
        setFieldValue(
          "devices",
          res.data.devices ? res.data.devices : ""
        );


        setIsLoading(false);
        setIsError(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [chooseCardId, onCardChoose, setFieldValue]);



  return (
    <Modal
      size="md"
      aria-labelledby="edit"
      centered
      className="modal pr-0"
      show={show}
      onHide={onHide}
    >
      {isLoading ? (
        <div className={classes.progresRoot}>
          <CircularProgress className={classes.progress} />
        </div>
      ) : !isLoading ? (
        <form onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title id="edit">Düzəliş et</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col-12 pl-4 pr-4">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-12">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">

                    <TextField
                      disabled
                      id="operation"
                      name="operation"
                      label="Əməliyyat"
                      placeholder="Əməliyyat"
                      className="w-100"
                      error={getInputClasses("operation")}
                      {...formik.getFieldProps("operation")}
                    />
                  </div>
                  {formik.touched.operation && formik.errors.operation ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{formik.errors.operation}</div>
                    </div>
                  ) : null}
                </div>
                <div className="col-12 col-md-12 col-lg-12">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <ReactDatePicker
                      label="Vaxt"
                      id="time"
                      name="time"
                      setValue={formik.setFieldValue}
                      value={formik.values.time}
                      error={getInputClasses("time")}
                      {...formik.getFieldProps("time")}
                    />
                  </div>
                  {formik.touched.time && formik.errors.time ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.time}
                      </div>
                    </div>
                  ) : null}

                </div>
                <div className=" col-12 col-md-12 col-lg-12">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">

                    <ReactSelectMulti
                      suggestions={device}
                      handleChangeSingle={handleChangeDevice}
                      single={deviceOption}
                      label="Qurğu  seçin"
                      placeholder="Qurğu seçin"
                      inputId="deviceIds"
                      error={getInputClasses("deviceIds")}
                      {...formik.getFieldProps("deviceIds")}
                    />
                  </div>
                  {formik.touched.deviceIds && formik.errors.deviceIds ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.deviceIds}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="col-12 col-md-12 col-lg-12">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="status"
                          name="status"
                          checked={formik.values.status}
                          {...formik.getFieldProps('status')}
                   
                        />
                      }
                      label="Aktiv"
                    />
                  </div>
                  {formik.touched.status && formik.errors.status ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{formik.errors.status}</div>
                    </div>
                  ) : null}

                </div>
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                onHide(false);
                formik.resetForm();
              }}
            >
              Ləğv et
            </Button>
            <Button type="submit" className={isEditLoading ? "px-9" : ""}>
              <span>Düzəliş et</span>
              {isEditLoading && (
                <span className="ml-3 spinner spinner-white"></span>
              )}
            </Button>
          </Modal.Footer>
        </form>
      ) : (
        <div className="p-5">
          <Alert variant="info">Xəta baş verdi.</Alert>
        </div>
      )}
    </Modal>
  );
}
